const Delimiter = /\[\[\[.+\]\]\]/g;

export const replacer = (data: string, key: string, replace: string): string => {
  const re = new RegExp(String.raw`\[\[\[${key}\]\]\]`, "g");
  return data.replaceAll(re, replace);
};

export const assertIfNotReplaced = (data: string): void => {
  const found = data.match(Delimiter);
  if (found) {
    throw new Error(`Invalid data - replacers still exist: ${found}`);
  }
};
